import React from 'react';
import { Link } from 'react-router-dom';

export const AdmnNav = () => {
  return (
    <nav className='color5 d-flex'>
       <img src='/logo.png' style={{ height: '50px',padding:'5px' }} alt='Logo Image' />
    </nav>
    // <nav class='color5'>
    //   <div class='d-flex'>
    //     <div class='mr-auto'>
    //      
    //     </div>
    //     {/* <Link to="/orgsignin" class="btn btn-primary color1 button mt-3 mr-2" type="submit" style={{height:"40px"}}>Organization Login</Link> */}
    //   </div>
    // </nav>
  );
};
export default AdmnNav;
